import { TimetableVersionRoomsMatrix } from '../../../../../../components/TimetableVersion/TimetableVersionDataAvailabilityMatrix/TimetableVersionRoomsMatrix';
import { TimetableVersionRoomsTableTable } from '../../../../../../components/TimetableVersion/TimetableVersionDataTables/TimetableVersionRoomsTable';
import { TimetableResourceDataPage, timetableResourceConfig } from '../TimetableResourceDataPage';

const roomConfig = timetableResourceConfig({
  availabilityResourceType: 'room',
  relationKey: 'rooms',
  lessonFilterColumn: 'rooms',
  importLabelKey: 'rooms.title',
  selectVersionUuids: (store) => Array.from(store.rooms.keys()),
  selectEntities: (basicData) => basicData.roomsData?.rooms,
  mapRow: (r) => ({
    uuid: r.uuid,
    name: r.name,
    count: 0,
    shortName: r.roomNumber ?? '',
    color: {},
  }),
  addEntities: (store, entities) => store.addRooms([...entities]),
  removeEntities: (store, uuids) => store.removeRooms(uuids),
  renderMatrix: ({ selected, loading, versionUuid, timeGridEntries, onChange }) => (
    <TimetableVersionRoomsMatrix
      timeGridEntries={timeGridEntries}
      versionUuid={versionUuid}
      selected={selected}
      loading={loading}
      onChange={onChange}
    />
  ),
  renderTable: ({ versionUuid, versionUuids, search, onRowSelection, onRemove, onShowLessonClick }) => (
    <TimetableVersionRoomsTableTable
      onRowSelection={onRowSelection}
      onShowLessonClick={onShowLessonClick}
      versionUuid={versionUuid}
      versionRoomUuids={versionUuids}
      search={search}
      onRemove={onRemove}
    />
  ),
});

export const PlanTimetableRooms = () => <TimetableResourceDataPage config={roomConfig} />;
